import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import AutomaticPurchase from '../../pages/TradingConfigPage/components/AutomaticPurchase/AutomaticPurchase';
import MobileCardConfiguration from '../../pages/TradingConfigPage/components/MobileCardConfiguration/MobileCardConfiguration';
import CustomExpansionPanel from '../CustomizedComponents/CustomExpansionPanel';
import PricingWrapper from './Price/PricingWrapper';
import PurchaseStepWrapper from './PurchaseStep/PurchaseStepWrapper';
import ContractEndDate from '../../pages/TradingConfigPage/components/ContractEndDate/ContractEndDate';
import ContractVolumeReport from '../../pages/TradingConfigPage/components/ContractVolumeExport/ContractVolumeExport';
import useAppContext from '../../hooks/context/useAppContext';
import userRoles from '../../constants/userRoles';

const dealStep = 'app.configuration.deal.step';
const editIcon = 'app.icon.edit';
const pricingTitle = 'app.configuration.pricing';
const automaticPurchaseTitle = 'app.configuration.automaticPurchase';
const mobileCardConfigurationTitle = 'app.configuration.mobileCard';
const contractEndDateCardTitle = 'app.configuration.contractEndDateCard';
const contractEndDateVolumeReport = 'app.configuration.contractVolumeReport';

const ConfigurationWrapper = ({ pricing, purschaseStepEle, purschaseStepGas, handlers, loaders, errors }) => {
  const [editable, setEditable] = useState(false);
  const [activePanelId, setActivePanelId] = useState(0);
  const [expandedState, setExpandedState] = useState(false);
  const { getUser } = useAppContext();

  const handleChange = (changeId) => {
    setActivePanelId(activePanelId === changeId ? 0 : changeId);
    setExpandedState((prevState) => (activePanelId !== 0 && activePanelId !== changeId ? prevState : !prevState));
  };

  const showSection = useCallback(
    (id) => {
      if (id === 6) {
        return [userRoles.ADMIN].includes(getUser().role);
      }
      return true;
    },
    [getUser],
  );

  const configurationExpansionPanels = useMemo(
    () => [
      {
        id: 1,
        title: dealStep,
        children: (
          <PurchaseStepWrapper
            purschaseStepEle={purschaseStepEle}
            purschaseStepGas={purschaseStepGas}
            handlers={handlers}
            editable={editable}
            setEditable={setEditable}
            loaders={loaders}
            errors={errors}
          />
        ),
      },
      {
        id: 2,
        title: pricingTitle,
        children: <PricingWrapper pricing={pricing} handlers={handlers} editable={editable} setEditable={setEditable} loaders={loaders} errors={errors} />,
      },
      {
        id: 3,
        title: automaticPurchaseTitle,
        children: <AutomaticPurchase pricing={pricing} handlers={handlers} editable={editable} setEditable={setEditable} loaders={loaders} errors={errors} />,
      },
      { id: 4, title: mobileCardConfigurationTitle, children: <MobileCardConfiguration editable={editable} setEditable={setEditable} /> },
      { id: 5, title: contractEndDateCardTitle, children: <ContractEndDate editable={editable} setEditable={setEditable} /> },

      { id: 6, title: contractEndDateVolumeReport, children: <ContractVolumeReport editable={editable} setEditable={setEditable} /> },
    ],
    [editable, errors, handlers, loaders, pricing, purschaseStepEle, purschaseStepGas],
  );

  return (
    <>
      {configurationExpansionPanels.map(
        ({ id, title, children }) =>
          showSection(id) && (
            <CustomExpansionPanel
              key={id}
              id={id}
              text={{ title: title, icon: editIcon }}
              active={activePanelId === id}
              handler={handleChange}
              editable={editable}
              setEditable={setEditable}
              expandedState={expandedState}>
              {children}
            </CustomExpansionPanel>
          ),
      )}
    </>
  );
};

ConfigurationWrapper.propTypes = {
  pricing: PropTypes.any,
  purschaseStepEle: PropTypes.any,
  purschaseStepGas: PropTypes.any,
  handlers: PropTypes.object,
  loaders: PropTypes.object,
  errors: PropTypes.object,
};

export default ConfigurationWrapper;
